import React, { useState } from "react";
import "./aboutYou.css";
import { useNavigate } from "react-router-dom";
import {
  resetOnboardingInfo,
  updateOnboardingInfo,
} from "../../redux/attorneyOnboardingSlice";
import { useDispatch, useSelector } from "react-redux";
import BackIcon from "./assets/backIcon.png";
import TextAreaWithCount from "../../components/input/new/textAreaWithCount";
import StepFooter from "./stepFooter";
import NarrowInputField from "../../components/input/new/narrowInputField";

const AboutYou = () => {
  const userId = useSelector(
    (state) => state.attorneyData.attorneyData?.user_id
  );

  const [aboutString, setAboutString] = useState("");
  const [aiSummary, setAISummary] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goBackToProfessionals = () => {
    dispatch(resetOnboardingInfo());
    navigate(`/attorney/${userId}/home`);
  };

  const handleNext = () => {
    dispatch(
      updateOnboardingInfo({ aboutYou: aboutString, lawyerSummary: aiSummary })
    );
  };

  const handleGenerate = async () => {
    if (!aboutString.trim()) return;

    setIsLoading(true);

    try {
      const response = await fetch("/api/attorney/ai/generateAttorneySummary", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message: aboutString }),
      });

      const data = await response.json();

      if (response.ok && data.summary) {
        setAISummary(data.summary);
      } else {
        console.error("Error generating summary:", data.error);
      }
    } catch (error) {
      console.error("Error generating summary:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Disable the StepFooter if the about text is empty (after trimming any whitespace)
  const isFooterDisabled = !aboutString.trim();

  return (
    <div className="you-container">
      <div className="category-profile-types">
        <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
          <div className="category-breadcrumb" onClick={goBackToProfessionals}>
            <img
              src={BackIcon}
              alt="Back Icon"
              style={{ width: "24px", height: "24px" }}
            />
            <a className="category-back-link">Back to professionals</a>
          </div>
          <h1 className="you-title">About you</h1>
          <p className="you-subtitle">
            This is your chance to introduce yourself to prospective clients on
            your profile. Highlight your background, areas of legal expertise,
            and your approach to handling cases.
          </p>
          <p className="you-subtitle2">
            About information{" "}
            <span className="title-optional-disclaimer">(Optional)</span>
          </p>
          <p className="about-you-body">
            Providing your direct contact information or inviting clients to
            schedule consultations outside of the Quidpro platform is not
            permitted under our{" "}
            <span className="bold-link-disclaimer">Profile Guidelines</span>
          </p>
          <TextAreaWithCount
            maxChars={2000}
            placeholder="Tell us about yourself..."
            value={aboutString}
            onChange={(e) => setAboutString(e.target.value)}
          />

          <h1 className="you-subtitle2">AI Summary</h1>
          <p className="about-you-body">
            The AI will generate a personalized highlight based on the
            information you provide in your "About" section.
          </p>
          <NarrowInputField
            name="ai-summary"
            placeholder="Your AI summary"
            isRequired={false}
            value={aiSummary}
            onChange={(e) => setAISummary(e.target.value)}
            halfWidth={false}
          />

          <p
            className="generate-button"
            onClick={handleGenerate}
            style={{ cursor: "pointer" }}
          >
            {isLoading
              ? "Generating..."
              : aiSummary
                ? "Regenerate"
                : "Generate"}
          </p>
        </div>
      </div>
      <StepFooter
        currentStep={6}
        totalSteps={9}
        location="/attorney/setup/work-experience"
        onNext={handleNext}
        disabled={isFooterDisabled} // Disable if no about text is entered
      />
    </div>
  );
};

export default AboutYou;
